import { render, staticRenderFns } from "./system_function_device.vue?vue&type=template&id=182b5b95"
import script from "./system_function_device.vue?vue&type=script&lang=js"
export * from "./system_function_device.vue?vue&type=script&lang=js"
import style0 from "./system_function_device.vue?vue&type=style&index=0&id=182b5b95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports